import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  TextField,
  Popover,
  Paper,
  InputAdornment,
  Checkbox,
  Chip,
  Grid,
  Menu,
  MenuItem,
} from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { useMediaQuery, useTheme } from "@mui/material";
import { Collapse, Divider } from "@mui/material";
import { Tooltip } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Search, Print, Download, Edit, Delete } from "@mui/icons-material";
import {
  fetchpos,
  deletepos,
  ApprovePO,
  fetchSuppliers,
} from "../../../Services/Services";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import axios from "axios";
// import * as XLSX from "xlsx";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { handlePrint } from "../Purchase_order/PurchaseOrderPrint";
import InfiniteScroll from "react-infinite-scroll-component";

pdfMake.vfs = pdfFonts.vfs;

const calculateValue = (item) => {
  let val = item.qty * item.price - item.discount;
  return (val + (val * item.tax) / 100).toFixed(2);
};

const ProjectList = () => {
  const [po, setpos] = useState([]);
  const [projects, setProjects] = useState([]);
  const [openRow, setOpenRow] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [poToDelete, setPoToDelete] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [suppliers, setSuppliers] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [approveAnchorEl, setApproveAnchorEl] = useState(null);
  const [poToApprove, setPoToApprove] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [showRemarkForPoId, setShowRemarkForPoId] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedPO, setExpandedPO] = useState(null);
   const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
  const [tempCustomDateRange, setTempCustomDateRange] = useState({
    from: "",
    to: "",
  });

  // ✅ NEW: Date Range States
  const dateInputRef = useRef(null);
  const [selectingDate, setSelectingDate] = useState(null);
  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [customDateRange, setCustomDateRange] = useState({
    from: "",
    to: "",
  });

  // ✅ Handle Custom Date Range Apply
   // ✅ Apply / Cancel helpers
  const handleApplyCustomDateRange = () => {
    if (tempCustomDateRange.from && tempCustomDateRange.to) {
      setCustomDateRange({ ...tempCustomDateRange });
      setFilters((prev) => ({ ...prev, date_range: "custom" }));
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    } else toast.warning("Please select both From and To dates");
  };
  // ✅ Handle Cancel Custom Date Range
  const handleCancelCustomDateRange = () => {
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
  };


  // 🔄 Reset Filters - Updated
  // ✅ handleReset updated
  const handleReset = () => {
    setFilters({
      po_number: "",
      supplier: "",
      approval_status: "Pending",
      date_range: "today",
    });
    setCustomDateRange({ from: "", to: "" });
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
  };

  // ✅ UPDATED: Added date_range to filters
  const [filters, setFilters] = useState({
    po_number: "",
    supplier: "",
    approval_status: "Pending",
    date_range: "today", // ✅ NEW
  });

  // ✅ NEW: Get Date Range Display Function
  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    switch (rangeType) {
      case "today":
        return formatDate(now);
      case "yesterday":
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        return formatDate(yesterday);
      case "this_week":
        const weekStart = new Date(now);
        weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
        return `${formatDate(weekStart)} to ${formatDate(now)}`;
      case "previous_week":
        const prevWeekEnd = new Date(now);
        prevWeekEnd.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
        const prevWeekStart = new Date(prevWeekEnd);
        prevWeekStart.setDate(prevWeekStart.getDate() - 6);
        return `${formatDate(prevWeekStart)} to ${formatDate(prevWeekEnd)}`;
      case "this_month":
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        return `${formatDate(monthStart)} to ${formatDate(now)}`;
      // case "current_year":
      //   const yearStart = new Date(now.getFullYear(), 0, 1);
      //   return `${formatDate(yearStart)} to ${formatDate(now)}`;
      // case "financial_year":
      //   let fyStart;
      //   if (now.getMonth() >= 3) {
      //     fyStart = new Date(now.getFullYear(), 3, 1);
      //   } else {
      //     fyStart = new Date(now.getFullYear() - 1, 3, 1);
      //   }
      //   return `${formatDate(fyStart)} to ${formatDate(now)}`;
      default:
        return "";
    }
  };

  // ✅ NEW: Format Date Display Function
  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  // ✅ NEW: Handle Reset Function
  // const handleReset = () => {
  //   setFilters({
  //     po_number: "",
  //     supplier: "",
  //     approval_status: "Pending",
  //     date_range: "today",
  //   });
  //   setCustomDateRange({ from: "", to: "" });
  // };

  // ✅ UPDATED: useEffect with customDateRange dependency
  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      const updatedFilters = {
        ...filters,
        from_date: customDateRange.from || "",
        to_date: customDateRange.to || "",
      };
      loadPo(1, true, updatedFilters);
    }, 1000);
    return () => {
      clearTimeout(handler);
    };
  }, [filters, customDateRange]);

  useEffect(() => {
    const loadSuppliers = async () => {
      try {
        const data = await fetchSuppliers();
        setSuppliers(Array.isArray(data) ? data : data.results || []);
      } catch (error) {}
    };
    loadSuppliers();
  }, []);

  const loadPo = async (pageNum = 1, reset = false, filterValues = filters) => {
    try {
      const data = await fetchpos(filterValues, pageNum);
      if (reset || pageNum === 1) {
        setProjects(Array.isArray(data) ? data.results : data.results || []);
      } else {
        setProjects((prev) => [
          ...prev,
          ...(Array.isArray(data) ? data.results : data.results || []),
        ]);
      }
      setHasMore(Array.isArray(data) ? data.next !== null : data.next !== null);
      setPage(pageNum);
    } catch (error) {
      toast.error("Failed to load po");
    }
  };

  // ✅ UPDATED: fetchMoreData with filters
  const fetchMoreData = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    const updatedFilters = {
      ...filters,
      from_date: customDateRange.from || "",
      to_date: customDateRange.to || "",
    };
    loadPo(nextPage, false, updatedFilters);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleApprove = async (po) => {
    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }
    try {
      const updated = await ApprovePO(
        po.id,
        approvedById,
        po.approval_status,
        remarkInput
      );
      setpos((prev) =>
        prev.map((item) => (item.id === po.id ? updated : item))
      );
      const UpdtedList = await fetchpos();
      setProjects(UpdtedList.results);
      toast.success(
        updated.approval_status === "Approved"
          ? "PO approved successfully!"
          : "PO unapproved successfully!"
      );
    } catch (error) {
      toast.error("Failed to approve PO.");
    }
  };

  const handleDownload = (po) => {
    const wb = XLSX.utils.book_new();

    const sanitizeSheetName = (name) => {
      if (!name) return "PO_Sheet";
      let sanitized = name
        .replace(/[:\\\/\?\*\[\]]/g, "_")
        .replace(/\s+/g, "_")
        .replace(/_+/g, "_")
        .replace(/^_|_$/g, "");
      sanitized = sanitized.substring(0, 31);
      return sanitized || "PO_Sheet";
    };

    const formatDate = (dateString) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    const headers = [
      "Sr.No",
      "Item Name",
      "Category",
      "Sub Category",
      "Description",
      "Quantity",
      "Unit",
      "Rate",
      "Amount",
      "Created At",
    ];

    const data = (po.items || []).map((item, index) => [
      index + 1,
      item.item_name || "",
      item.category_name || "",
      item.sub_category_name || "",
      item.description || "",
      item.quantity || 0,
      item.unit_name || "",
      parseFloat(item.rate || 0).toFixed(2),
      parseFloat(item.amount || 0).toFixed(2),
      formatDate(po.created_at),
    ]);

    const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);

    const colWidths = headers.map((header, i) => {
      const maxLength = Math.max(
        header.length,
        ...data.map((row) => String(row[i] || "").length)
      );
      return { wch: Math.min(maxLength + 2, 50) };
    });
    ws["!cols"] = colWidths;

    const range = XLSX.utils.decode_range(ws["!ref"]);

    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_col(C) + "1";
      if (!ws[cellAddress]) continue;
      ws[cellAddress].s = {
        fill: { fgColor: { rgb: "4472C4" } },
        font: { bold: true, color: { rgb: "FFFFFF" }, sz: 12 },
        alignment: { horizontal: "center", vertical: "center", wrapText: true },
        border: {
          top: { style: "thin", color: { rgb: "000000" } },
          bottom: { style: "thin", color: { rgb: "000000" } },
          left: { style: "thin", color: { rgb: "000000" } },
          right: { style: "thin", color: { rgb: "000000" } },
        },
      };
    }

    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellAddress]) continue;
        ws[cellAddress].s = {
          alignment: { horizontal: "center", vertical: "center" },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
          fill: { fgColor: { rgb: R % 2 === 0 ? "F2F2F2" : "FFFFFF" } },
        };
      }
    }

    const sheetName = sanitizeSheetName(po.po_number);
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    const xlsData = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
      cellStyles: true,
    });

    const fileName = `${po.po_number || "PO"}_${formatDate(
      po.created_at
    )}.xlsx`;
    saveAs(new Blob([xlsData], { type: "application/octet-stream" }), fileName);
    toast.success(`Excel for ${po.po_number} downloaded successfully!`);
  };

  const handleEdit = (po) => {
    navigate("/dashboard/po-form", { state: { poData: po, isEdit: true } });
  };

  const handleDeleteClick = (po) => {
    setPoToDelete(po);
    setDeleteDialogOpen(true);
  };

  const confirmDelete = async () => {
    try {
      await deletepos(poToDelete.id);
      setProjects((prev) => prev.filter((p) => p.id !== poToDelete.id));
      setPoToDelete(null);
      toast.success("Purchase order deleted successfully");
    } catch (error) {
      toast.error("Failed to delete purchase order");
    }
  };

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  const handleClick = () => {
    navigate("/dashboard/po-form");
  };
function formatOnlyDate(dateTimeString) {
  if (!dateTimeString) return "N/A";

  // Take only the date part (before T)
  const datePart = dateTimeString.split("T")[0];  // "2025-12-02"

  const [year, month, day] = datePart.split("-");

  return `${day}-${month}-${year}`;
}

  const userRole = localStorage.getItem("role");

  return (
    <Box sx={{ px: 0, pt: 0, mt: -3, maxWidth: 1200, mx: "auto" }}>
      <Box sx={{ mt: -3, pt: 0, mb: 1, width: "100%" }}>
        {/* ✅ DESKTOP VIEW */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            flexWrap: "wrap",
            alignItems: "center",
            gap: 1,
            justifyContent: "space-between",
          }}
        >
          {/* Status Filter */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              flexShrink: 0,
            }}
          >
            <label style={{ fontSize: "12px" }}>
              <input
                type="radio"
                name="approval_status"
                value="Pending"
                checked={filters.approval_status === "Pending"}
                onChange={handleFilterChange}
                style={{ marginRight: "5px", transform: "scale(0.6)" }}
              />
              Pending
            </label>

            <label style={{ fontSize: "12px" }}>
              <input
                type="radio"
                name="approval_status"
                value="Approved"
                checked={filters.approval_status === "Approved"}
                onChange={handleFilterChange}
                style={{ marginRight: "5px", transform: "scale(0.6)" }}
              />
              Approved
            </label>

            <label style={{ fontSize: "12px" }}>
              <input
                type="radio"
                name="approval_status"
                value="Reject"
                checked={filters.approval_status === "Reject"}
                onChange={handleFilterChange}
                style={{ marginRight: "5px", transform: "scale(0.6)" }}
              />
              Rejected
            </label>
          </Box>

          {/* ✅ NEW: Date Range Dropdown */}
          <TextField
            label="Date Range"
            value={
              filters.date_range === "custom" &&
              customDateRange.from &&
              customDateRange.to
                ? `${formatDateDisplay(
                    customDateRange.from
                  )} to ${formatDateDisplay(customDateRange.to)}`
                : filters.date_range === "today"
                ? "Today"
                : filters.date_range === "yesterday"
                ? "Yesterday"
                : filters.date_range === "this_week"
                ? "This Week"
                : filters.date_range === "this_month"
                ? "This Month"
                : "Select Date Range"
            }
            onClick={(e) => setDateMenuAnchor(e.currentTarget)}
            size="small"
            InputProps={{
              readOnly: true,
              endAdornment: (
                <IconButton size="small" edge="end">
                  <ArrowDropDownIcon />
                </IconButton>
              ),
            }}
            sx={{
              cursor: "pointer",
              minWidth: 180,
              "& .MuiInputBase-input": {
                fontSize: "0.75rem",
                padding: "4px 8px",
              },
              "& .MuiInputBase-root": {
                height: 30,
                borderRadius: 0,
              },
              "& .MuiInputLabel-root": {
                fontSize: "0.7rem",
              },
            }}
          />

          {/* Search fields */}
          <Box display="flex" gap={1} flex={1}>
            <TextField
              label="Search PO Number"
              size="small"
              name="po_number"
              value={filters.po_number}
              onChange={handleFilterChange}
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
              fullWidth
            />

            <TextField
              label="Search Supplier"
              size="small"
              name="supplier"
              value={filters.supplier}
              onChange={handleFilterChange}
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
              fullWidth
            />
          </Box>
        </Box>

        {/* ✅ MOBILE VIEW */}
        <Box
          sx={{
            display: { xs: "block", md: "none" },
          }}
        >
          {/* Status Filter - Mobile */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 1.5,
              mb: 1.5,
              p: 1,
              bgcolor: "#f5f5f5",
              borderRadius: 1,
            }}
          >
            <Box sx={{ display: "flex", gap: 1.5 }}>
              <label
                style={{
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <input
                  type="radio"
                  name="approval_status"
                  value="Pending"
                  checked={filters.approval_status === "Pending"}
                  onChange={handleFilterChange}
                  style={{ marginRight: "5px" }}
                />
                Pending
              </label>

              <label
                style={{
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <input
                  type="radio"
                  name="approval_status"
                  value="Approved"
                  checked={filters.approval_status === "Approved"}
                  onChange={handleFilterChange}
                  style={{ marginRight: "5px" }}
                />
                Approved
              </label>

              <label
                style={{
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <input
                  type="radio"
                  name="approval_status"
                  value="Reject"
                  checked={filters.approval_status === "Reject"}
                  onChange={handleFilterChange}
                  style={{ marginRight: "5px" }}
                />
                Rejected
              </label>
            </Box>
          </Box>

          {/* ✅ NEW: Date Range Dropdown - Mobile */}
          <Box sx={{ px: 1, mb: 1.5 }}>
            <TextField
              fullWidth
              label="Date Range"
              value={
                filters.date_range === "custom" &&
                customDateRange.from &&
                customDateRange.to
                  ? `${formatDateDisplay(
                      customDateRange.from
                    )} to ${formatDateDisplay(customDateRange.to)}`
                  : filters.date_range === "today"
                  ? "Today"
                  : filters.date_range === "yesterday"
                  ? "Yesterday"
                  : filters.date_range === "this_week"
                  ? "This Week"
                  : filters.date_range === "this_month"
                  ? "This Month"
                  : "Select Date Range"
              }
              onClick={(e) => setDateMenuAnchor(e.currentTarget)}
              size="small"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <IconButton size="small" edge="end">
                    <ArrowDropDownIcon />
                  </IconButton>
                ),
              }}
              sx={{
                cursor: "pointer",
                "& .MuiInputBase-root": {
                  height: 40,
                },
              }}
            />
          </Box>

          {/* Search Fields Grid - Mobile */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
              },
              gap: 1.5,
              px: 1,
            }}
          >
            <TextField
              label="Search PO Number"
              size="small"
              name="po_number"
              value={filters.po_number}
              onChange={handleFilterChange}
              fullWidth
              sx={{
                "& .MuiInputBase-root": {
                  height: 40,
                },
              }}
            />

            <TextField
              label="Search Supplier"
              size="small"
              name="supplier"
              value={filters.supplier}
              onChange={handleFilterChange}
              fullWidth
              sx={{
                "& .MuiInputBase-root": {
                  height: 40,
                },
              }}
            />
          </Box>
        </Box>
      </Box>

      {/* ✅ NEW: Hidden Date Input for Custom Range */}
      <input
        ref={dateInputRef}
        type="date"
        style={{
          position: "absolute",
          opacity: 0,
          pointerEvents: "none",
          width: "1px",
          height: "1px",
        }}
        value={
          selectingDate === "from" ? customDateRange.from : customDateRange.to
        }
        min={selectingDate === "to" ? customDateRange.from : undefined}
        onChange={(e) => {
          const selectedDate = e.target.value;

          if (selectingDate === "from") {
            setCustomDateRange((prev) => ({ ...prev, from: selectedDate }));
            setSelectingDate("to");
            setTimeout(() => {
              dateInputRef.current?.showPicker();
            }, 100);
          } else if (selectingDate === "to") {
            setCustomDateRange((prev) => ({ ...prev, to: selectedDate }));
            setFilters((prev) => ({ ...prev, date_range: "custom" }));
            setSelectingDate(null);
            setDateMenuAnchor(null);
          }
        }}
      />

      {/* ✅ NEW: Date Range Menu */}
      {/* Date Range Menu - UPDATED */}
      <Menu
        anchorEl={dateMenuAnchor}
        open={Boolean(dateMenuAnchor)}
        onClose={() => {
          setDateMenuAnchor(null);
          setShowCustomDateInputs(false);
          setTempCustomDateRange({ from: "", to: "" });
        }}
        PaperProps={{
          sx: { width: 350, maxHeight: 500 },
        }}
      >
        {/* Today */}
        <MenuItem
          onClick={() => {
            setFilters((prev) => ({ ...prev, date_range: "today" }));
            setCustomDateRange({ from: "", to: "" });
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography variant="body2">Today</Typography>
            <Typography variant="caption" color="text.secondary">
              {getDateRangeDisplay("today")}
            </Typography>
          </Box>
        </MenuItem>

        {/* Yesterday */}
        <MenuItem
          onClick={() => {
            setFilters((prev) => ({ ...prev, date_range: "yesterday" }));
            setCustomDateRange({ from: "", to: "" });
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography variant="body2">Yesterday</Typography>
            <Typography variant="caption" color="text.secondary">
              {getDateRangeDisplay("yesterday")}
            </Typography>
          </Box>
        </MenuItem>

        {/* This Week */}
        <MenuItem
          onClick={() => {
            setFilters((prev) => ({ ...prev, date_range: "this_week" }));
            setCustomDateRange({ from: "", to: "" });
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography variant="body2">This Week</Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontSize: "0.65rem" }}
            >
              {getDateRangeDisplay("this_week")}
            </Typography>
          </Box>
        </MenuItem>

        {/* Previous Week */}
        <MenuItem
          onClick={() => {
            setFilters((prev) => ({ ...prev, date_range: "previous_week" }));
            setCustomDateRange({ from: "", to: "" });
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography variant="body2">Previous Week</Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontSize: "0.65rem" }}
            >
              {getDateRangeDisplay("previous_week")}
            </Typography>
          </Box>
        </MenuItem>

        {/* This Month */}
        <MenuItem
          onClick={() => {
            setFilters((prev) => ({ ...prev, date_range: "this_month" }));
            setCustomDateRange({ from: "", to: "" });
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography variant="body2">This Month</Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontSize: "0.65rem" }}
            >
              {getDateRangeDisplay("this_month")}
            </Typography>
          </Box>
        </MenuItem>

        {/* Current Year */}
        {/* <MenuItem
          onClick={() => {
            setFilters((prev) => ({ ...prev, date_range: "current_year" }));
            setCustomDateRange({ from: "", to: "" });
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography variant="body2">Current Year</Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontSize: "0.65rem" }}
            >
              {getDateRangeDisplay("current_year")}
            </Typography>
          </Box>
        </MenuItem> */}

        {/* Financial Year */}
        {/* <MenuItem
          onClick={() => {
            setFilters((prev) => ({ ...prev, date_range: "financial_year" }));
            setCustomDateRange({ from: "", to: "" });
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography variant="body2">Financial Year</Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontSize: "0.65rem" }}
            >
              {getDateRangeDisplay("financial_year")}
            </Typography>
          </Box>
        </MenuItem> */}

        {/* <Divider /> */}

        {/* ✅ Custom Date Range - Expandable */}
        <MenuItem
          onClick={() => setShowCustomDateInputs(!showCustomDateInputs)}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            bgcolor: showCustomDateInputs ? "#e3f2fd" : "inherit",
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}
          >
            Custom Date Range
          </Typography>
          {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
        </MenuItem>

        {/* ✅ Both Date Pickers Together */}
        <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
          <Box
            sx={{
              px: 2,
              py: 2,
              bgcolor: "#f5f5f5",
              borderTop: "1px solid #e0e0e0",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ mb: 1, display: "block" }}
            >
              Select Date Range
            </Typography>

            {/* From and To Date Inputs Side by Side */}
            <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
              <TextField
                label="From Date"
                type="date"
                size="small"
                value={tempCustomDateRange.from}
                onChange={(e) =>
                  setTempCustomDateRange((prev) => ({
                    ...prev,
                    from: e.target.value,
                  }))
                }
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  max: tempCustomDateRange.to || undefined,
                }}
                sx={{
                  flex: 1,
                  "& .MuiInputBase-root": {
                    height: 40,
                    fontSize: "0.75rem",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "0.75rem",
                  },
                }}
              />

              <TextField
                label="To Date"
                type="date"
                size="small"
                value={tempCustomDateRange.to}
                onChange={(e) =>
                  setTempCustomDateRange((prev) => ({
                    ...prev,
                    to: e.target.value,
                  }))
                }
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  min: tempCustomDateRange.from || undefined,
                }}
                sx={{
                  flex: 1,
                  "& .MuiInputBase-root": {
                    height: 40,
                    fontSize: "0.75rem",
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: "0.75rem",
                  },
                }}
              />
            </Box>

            {/* Selected Range Preview */}
            {tempCustomDateRange.from && tempCustomDateRange.to && (
              <Typography
                variant="caption"
                sx={{
                  display: "block",
                  mb: 1.5,
                  p: 1,
                  bgcolor: "#e8f5e9",
                  borderRadius: 1,
                  textAlign: "center",
                  color: "#2e7d32",
                  fontWeight: 500,
                }}
              >
                📅 {formatDateDisplay(tempCustomDateRange.from)} to{" "}
                {formatDateDisplay(tempCustomDateRange.to)}
              </Typography>
            )}

            {/* Apply and Cancel Buttons */}
            <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
              <Button
                variant="outlined"
                size="small"
                onClick={handleCancelCustomDateRange}
                sx={{
                  fontSize: "0.7rem",
                  textTransform: "none",
                  borderRadius: 1,
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                size="small"
                onClick={handleApplyCustomDateRange}
                disabled={!tempCustomDateRange.from || !tempCustomDateRange.to}
                sx={{
                  fontSize: "0.7rem",
                  textTransform: "none",
                  borderRadius: 1,
                }}
              >
                Apply
              </Button>
            </Box>
          </Box>
        </Collapse>
      </Menu>

      <InfiniteScroll
        dataLength={projects.length}
        next={fetchMoreData}
        hasMore={hasMore}
        loader={<h4>Loading...</h4>}
        endMessage={<p style={{ textAlign: "center" }}>No more records!</p>}
      >
        {/* 🔥 MOBILE VIEW - Expandable List */}
        {isMobile ? (
          <Box sx={{ bgcolor: "background.paper" }}>
            {projects.map((po, index) => (
              <Box key={po.id}>
                {/* Main Row - Always Visible */}
                <Box
                  onClick={() =>
                    setExpandedPO(expandedPO === po.id ? null : po.id)
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    cursor: "pointer",
                    bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                    "&:active": {
                      bgcolor: "#e3f2fd",
                    },
                    borderLeft: `4px solid ${
                      po.approval_status === "Approved"
                        ? "#4caf50"
                        : po.approval_status === "Reject"
                        ? "#f44336"
                        : "#ff9800"
                    }`,
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    {/* PO Number & Status */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#666",
                          minWidth: 25,
                        }}
                      >
                        #{index + 1}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.85rem",
                          flex: 1,
                        }}
                      >
                        {po.po_number}
                      </Typography>
                    </Box>

                    {/* Supplier & Date */}
                    <Typography
                      sx={{
                        fontSize: "0.75rem",
                        color: "#666",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <span style={{ fontWeight: 500 }}>
                        {suppliers
                          .find((s) => s.id === po.supplier)
                          ?.name?.substring(0, 20) || `Supplier ${po.supplier}`}
                      </span>
                      <span style={{ color: "#999" }}>•</span>
                      <span style={{ fontSize: "0.7rem" }}>
                        {new Date(po.created_at).toLocaleDateString("en-GB")}
                      </span>
                    </Typography>
                  </Box>

                  {/* Expand Icon */}
                  <IconButton size="small" sx={{ ml: 1 }}>
                    {expandedPO === po.id ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </IconButton>
                </Box>

                {/* Expanded Details */}
                <Collapse
                  in={expandedPO === po.id}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      px: 1.5,
                      py: 1,
                      bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
                      borderLeft: `4px solid ${
                        po.approval_status === "Approved"
                          ? "#4caf50"
                          : po.approval_status === "Reject"
                          ? "#f44336"
                          : "#ff9800"
                      }`,
                    }}
                  >
                    {/* Detailed Info - 2 Column Grid for compact layout */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 0.8,
                        mb: 1,
                      }}
                    >
                      {/* Supplier Full */}
                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          SUPPLIER
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.75rem",
                            fontWeight: 500,
                            color: "#333",
                          }}
                        >
                          {suppliers.find((s) => s.id === po.supplier)?.name ||
                            `Supplier ${po.supplier}`}
                        </Typography>
                      </Box>

                      {/* Created By */}
                      {po.created_by_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            CREATED BY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {po.created_by_name}
                          </Typography>
                        </Box>
                      )}

                      {/* Approved By */}
                      {po.approved_name && (
                        <Box>
                          <Typography
                            sx={{
                              fontSize: "0.6rem",
                              color: "#999",
                              letterSpacing: "0.5px",
                            }}
                          >
                            APPROVED BY
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "#555",
                            }}
                          >
                            {po.approved_name}
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    {/* Billing Address - Compact */}
                    <Box sx={{ mb: 0.8 }}>
                      <Typography
                        sx={{
                          fontSize: "0.6rem",
                          color: "#999",
                          letterSpacing: "0.5px",
                          mb: 0.3,
                        }}
                      >
                        BILLING ADDRESS
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#555",
                          lineHeight: 1.3,
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      >
                        {po.billing_address}
                      </Typography>
                    </Box>

                    {/* Shipping Address - Compact */}
                    <Box sx={{ mb: 0.8 }}>
                      <Typography
                        sx={{
                          fontSize: "0.6rem",
                          color: "#999",
                          letterSpacing: "0.5px",
                          mb: 0.3,
                        }}
                      >
                        SHIPPING ADDRESS
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#555",
                          lineHeight: 1.3,
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                        }}
                      >
                        {po.shipping_address}
                      </Typography>
                    </Box>

                    {/* Remarks - Only if exists */}
                    {po.remarks && (
                      <Box sx={{ mb: 0.8 }}>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                            mb: 0.3,
                          }}
                        >
                          REMARKS
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.7rem",
                            color: "#555",
                            fontStyle: "italic",
                            lineHeight: 1.3,
                          }}
                        >
                          {po.remarks}
                        </Typography>
                      </Box>
                    )}

                    <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                    {/* Action Buttons - Compact & Attractive */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      {/* Approve - Only Admin */}
                      {userRole != "Staff" && (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            bgcolor:
                              po.approval_status === "Approved"
                                ? "#e8f5e9"
                                : po.approval_status === "Reject"
                                ? "#ffebee"
                                : "#fff3e0",
                            px: 1,
                            py: 0.5,
                            borderRadius: "6px",
                            border: `1px solid ${
                              po.approval_status === "Approved"
                                ? "#4caf50"
                                : po.approval_status === "Reject"
                                ? "#f44336"
                                : "#ff9800"
                            }`,
                          }}
                        >
                          <Checkbox
                            checked={
                              po.approval_status === "Approved" ||
                              po.approval_status === "Reject"
                            }
                            onChange={(e) => {
                              e.stopPropagation();
                              setApproveAnchorEl(e.currentTarget);
                              setPoToApprove(po);
                            }}
                            sx={{
                              padding: 0,
                              transform: "scale(0.75)",
                              color:
                                po.approval_status === "Approved"
                                  ? "#4caf50"
                                  : po.approval_status === "Reject"
                                  ? "#f44336"
                                  : "#ff9800",
                              "&.Mui-checked": {
                                color:
                                  po.approval_status === "Approved"
                                    ? "#4caf50"
                                    : "#f44336",
                              },
                            }}
                          />
                          <Typography
                            sx={{
                              fontSize: "0.7rem",
                              fontWeight: 600,
                              color:
                                po.approval_status === "Approved"
                                  ? "#2e7d32"
                                  : po.approval_status === "Reject"
                                  ? "#c62828"
                                  : "#f57c00",
                            }}
                          >
                            {po.approval_status === "Approved"
                              ? "Approved"
                              : po.approval_status === "Reject"
                              ? "Rejected"
                              : "Approve"}
                          </Typography>
                        </Box>
                      )}

                      {/* Print & Download - Compact Buttons */}
                      <Box sx={{ display: "flex", gap: 0.6 }}>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handlePrint(po);
                          }}
                          sx={{
                            bgcolor: "#e3f2fd",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#bbdefb",
                              transform: "scale(1.05)",
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Print sx={{ fontSize: "1rem", color: "#1976d2" }} />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDownload(po);
                          }}
                          sx={{
                            bgcolor: "#e8f5e9",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#c8e6c9",
                              transform: "scale(1.05)",
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Download
                            sx={{ fontSize: "1rem", color: "#4caf50" }}
                          />
                        </IconButton>
                      </Box>
                    </Box>
                  </Box>
                </Collapse>

                {/* Divider between items */}
                <Divider />
              </Box>
            ))}
          </Box>
        ) : (
          /* 💻 DESKTOP VIEW - Table */
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: "88vh",
              overflow: "auto",
            }}
          >
            <Table
              stickyHeader
              size="small"
              sx={{
                minWidth: "max-content",
                "& td, & th": {
                  borderBottom: "1px solid #ccc",
                  whiteSpace: "nowrap",
                },
              }}
            >
              <TableHead
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    fontSize: "0.75rem",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#2196f3" : "#333",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                  },
                }}
              >
                <TableRow
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "& th": {
                      fontWeight: "bold",
                      color: "#333",
                      borderBottom: "1px solid #999",
                      whiteSpace: "nowrap",
                    },
                  }}
                >
                  {userRole != "Staff" && (
                    <TableCell
                      sx={{
                        backgroundColor: "#f5f5f5",
                        zIndex: 3,
                        minWidth: 80,
                      }}
                      align="center"
                    >
                      Approve
                    </TableCell>
                  )}

                  <TableCell
                    sx={{
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                      minWidth: 80,
                    }}
                    align="center"
                  >
                    S.No.
                  </TableCell>

                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                      minWidth: 120,
                    }}
                    align="center"
                  >
                    PO Number
                  </TableCell>

                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Supplier</TableCell>
                  <TableCell align="center">Billing Address</TableCell>
                  <TableCell align="center">Shipping Address</TableCell>
                  <TableCell align="center">Created At</TableCell>
                  <TableCell align="center">Created By</TableCell>
                  <TableCell align="center">Approved By</TableCell>
                  <TableCell align="center">Remarks</TableCell>

                  <TableCell
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#fff",
                      zIndex: 3,
                    }}
                    align="center"
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {projects.map((po, index) => (
                  <React.Fragment key={po.id}>
                    <TableRow
                      hover
                      sx={{
                        backgroundColor:
                          index % 2 === 0 ? "#fafafa" : "#ffffff",
                        "&:hover": {
                          backgroundColor: "#e3f2fd",
                          "& td": {
                            backgroundColor: "#e3f2fd !important",
                          },
                        },
                        "& td": {
                          padding: "0px",
                          paddingLeft: 1,
                          paddingRight: 1,
                          fontSize: "0.7rem",
                          fontSize: { xs: "0.65rem", sm: "0.75rem" },
                          whiteSpace: "nowrap",
                          color: (theme) =>
                            theme.palette.mode === "dark" ? "white" : "inherit",
                          backgroundColor: (theme) =>
                            theme.palette.mode === "dark" ? "black" : "inherit",
                        },
                      }}
                    >
                      {userRole != "Staff" && (
                        <TableCell
                          sx={{
                            backgroundColor: "#fafafa",
                            zIndex: 2,
                            minWidth: 80,
                          }}
                          align="center"
                        >
                          <Checkbox
                            checked={
                              po.approval_status === "Approved" ||
                              po.approval_status === "Reject"
                            }
                            onChange={(e) => {
                              setApproveAnchorEl(e.currentTarget);
                              setPoToApprove(po);
                            }}
                            sx={{
                              padding: 0,
                              paddingLeft: 1,
                              paddingRight: 1,
                              transform: "scale(0.6)",
                              color:
                                po.approval_status === "Approved"
                                  ? "green"
                                  : po.approval_status === "Reject"
                                  ? "red"
                                  : "grey",
                              "&.Mui-checked": {
                                color:
                                  po.approval_status === "Approved"
                                    ? "green"
                                    : "red",
                              },
                            }}
                          />
                        </TableCell>
                      )}

                      <TableCell
                        sx={{
                          backgroundColor: "#fafafa",
                          zIndex: 2,
                          minWidth: 80,
                        }}
                        align="center"
                      >
                        {index + 1}
                      </TableCell>

                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 0,
                          backgroundColor: "#fafafa",
                          zIndex: 2,
                          minWidth: 120,
                        }}
                        align="center"
                      >
                        {po.po_number}
                      </TableCell>

                      <TableCell align="center">
                        <Chip
                          label={
                            po.approval_status === "Approved"
                              ? "Approved"
                              : po.approval_status === "Reject"
                              ? "Reject"
                              : "Pending"
                          }
                          color={
                            po.approval_status === "Approved"
                              ? "success"
                              : po.approval_status === "Reject"
                              ? "error"
                              : "warning"
                          }
                          variant="outlined"
                          size="small"
                          sx={{
                            height: "10px",
                            transform: "scale(0.8)",
                            "& .MuiChip-label": {
                              padding: "0 6px",
                            },
                          }}
                        />
                      </TableCell>

                      <TableCell align="center">
                        {suppliers.find((s) => s.id === po.supplier)?.name ||
                          `Supplier ${po.supplier}`}
                      </TableCell>

                      <TableCell>
                        <Tooltip title={po.billing_address} arrow>
                          <span>{truncateText(po.billing_address, 20)}</span>
                        </Tooltip>
                      </TableCell>

                      <TableCell>
                        <Tooltip title={po.shipping_address} arrow>
                          <span>{truncateText(po.shipping_address, 20)}</span>
                        </Tooltip>
                      </TableCell>

                      <TableCell align="center">
                        {formatOnlyDate(po.created_at)}
                      </TableCell>

                      <TableCell align="center">
                        {po.created_by_name ? po.created_by_name : "N/A"}
                      </TableCell>

                      <TableCell align="center">
                        {po.approved_name ? po.approved_name : ""}
                      </TableCell>

                      <TableCell>
                        <Tooltip title={po.remarks || ""} arrow>
                          <span>{truncateText(po.remarks || "", 20)}</span>
                        </Tooltip>
                      </TableCell>

                      <TableCell
                        sx={{
                          position: "sticky",
                          right: 0,
                          zIndex: 3,
                        }}
                        align="center"
                      >
                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          size="small"
                          color="primary"
                          onClick={() => handlePrint(po)}
                        >
                          <Print transform="scale(0.6)" />
                        </IconButton>
                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          color="primary"
                          size="small"
                          onClick={() => handleDownload(po)}
                        >
                          <Download transform="scale(0.6)" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </InfiniteScroll>

      <ToastContainer position="top-right" autoClose={3000} />

      {/* Approve/Reject Popover */}
      <Popover
        open={Boolean(approveAnchorEl)}
        anchorEl={approveAnchorEl}
        onClose={() => {
          setApproveAnchorEl(null);
          setPoToApprove(null);
          setRemarkInput("");
          setShowRemarkForPoId(null);
          setActionType(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2, minWidth: 250 }}>
          {showRemarkForPoId === poToApprove?.id ? (
            <>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Please enter remark before{" "}
                {actionType === "Approved" ? "approving" : "rejecting"}:
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={remarkInput}
                onChange={(e) => setRemarkInput(e.target.value)}
                placeholder="Enter remark"
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                }}
              >
                <Button
                  color={actionType === "Approved" ? "success" : "error"}
                  size="small"
                  onClick={() => {
                    if (!remarkInput.trim()) {
                      toast.error("Remark is required!");
                      return;
                    }
                    handleApprove({
                      ...poToApprove,
                      approval_status: actionType,
                      remarks: remarkInput,
                    });
                    setApproveAnchorEl(null);
                    setPoToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForPoId(null);
                    setActionType(null);
                  }}
                >
                  Yes
                </Button>
                <Button
                  size="small"
                  onClick={() => {
                    setApproveAnchorEl(null);
                    setPoToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForPoId(null);
                    setActionType(null);
                  }}
                >
                  No
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Do you want to approve or reject this indent?
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                }}
              >
                <Button
                  color="success"
                  size="small"
                  onClick={() => {
                    setShowRemarkForPoId(poToApprove?.id);
                    setActionType("Approved");
                  }}
                >
                  Approve
                </Button>
                <Button
                  color="error"
                  size="small"
                  onClick={() => {
                    setShowRemarkForPoId(poToApprove?.id);
                    setActionType("Reject");
                  }}
                >
                  Reject
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Popover>

      {/* Delete Popover */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setPoToDelete(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, maxWidth: 200 }}>
          <Typography variant="body2" gutterBottom>
            Are you sure you want to delete <strong>{poToDelete?.name}</strong>?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl(null);
                setPoToDelete(null);
              }}
            >
              Close
            </Button>
            <Button
              size="small"
              color="error"
              onClick={async () => {
                await confirmDelete(poToDelete);
                setAnchorEl(null);
                setPoToDelete(null);
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};

export default ProjectList;
